import { styled } from '@mui/system';

const MainMenuSiteName = styled('div')({
    paddingLeft: '0.625rem',
    fontSize: '1.3125rem',
    fontWeight: 700,
    color: 'var(--gov-color-white)',
    whiteSpace: 'nowrap', // Prevent text wrapping if necessary
});

export default MainMenuSiteName;